import { Box, Grid, Paper, Typography } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const SummaryCards = () => {
  const metrics = [
    { title: "Total Leads", value: 156, change: "+12.5%", up: true, icon: "👤" },
    { title: "Conversion Rate", value: "22.4%", change: "+3.2%", up: true, icon: "✅" },
    { title: "Total Revenue", value: "$121K", change: "+8.7%", up: true, icon: "💰" },
    { title: "Avg Deal Size", value: "$3455", change: "-2.1%", up: false, icon: "🎯" },
  ];

  return (
    <Grid container spacing={2}>
      {metrics.map((metric, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="h6">{metric.icon} {metric.title}</Typography>
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>{metric.value}</Typography>
            <Box display="flex" alignItems="center" color={metric.up ? "green" : "red"}>
              {metric.up ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
              <Typography variant="body2" ml={0.5}>{metric.change}</Typography>
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryCards;
